import { render, staticRenderFns } from "./XPagination.vue?vue&type=template&id=27e36b00&"
import script from "./XPagination.vue?vue&type=script&lang=js&"
export * from "./XPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports